<template>
    <div class="slider-wrap">
        <div class="row slider-bg">
            <div class="col">
                <div class="description-block" @click="setSelection(1)">
                    <span class="heading">We're starting from scratch <span class="info" id="basics">i</span></span>
                    <b-popover :target="`basics`" :placement="`top`" triggers="hover focus">
                        <p>Although aware of electric vehicles and the benefits over their diesel and petrol counterparts,
                            we are just starting out and unclear about which electric cars or vans would be suitable.</p>
                    </b-popover>
                    <div class="slider-spacer"></div>
                </div>
            </div>
            <div class="col">
                <div class="description-block move-left" @click="setSelection(2)">
                    <span class="heading">We have some knowledge <span class="info" id="getting-by">i</span></span>
                    <b-popover :target="`getting-by`" :placement="`top`" triggers="hover focus">
                        <p>We have identified that electric vehicles will be a part of our fleet in the future but have not
                            yet established timings or identified which electric cars or vans would be suitable.</p>
                    </b-popover>
                    <div class="slider-spacer"></div>
                </div>
            </div>
            <div class="col">
                <div class="description-block move-left" @click="setSelection(3)">
                    <span class="heading">We've got the basics covered <span class="info" id="average">i</span></span>
                    <b-popover :target="`average`" :placement="`top`" triggers="hover focus">
                        <p>Although we are looking at introducing electric vehicles with a future vision in mind, we are yet
                            to establish clear plans. However, we have started looking at the best electric car and van
                            options.</p>
                    </b-popover>
                    <div class="slider-spacer"></div>
                </div>
            </div>
            <div class="col">
                <div class="description-block move-left" @click="setSelection(4)">
                    <span class="heading">We're pretty confident <span class="info" id="confident">i</span></span>
                    <b-popover :target="`confident`" :placement="`top`" triggers="hover focus">
                        <p>We have identified the full value opportunity of introducing electric vehicles into our fleet and
                            have identified electric cars or vans suitable for our business, which we will try out
                            shortly.</p>
                    </b-popover>
                    <div class="slider-spacer"></div>
                </div>
            </div>
            <div class="col">
                <div class="description-block move-right" @click="setSelection(5)">
                    <span class="heading">We're EV experts <span class="info" id="expert">i</span></span>
                    <b-popover :target="`expert`" :placement="`top`" triggers="hover focus">
                        <p>With clear targets for transition, we are proactively driving the change towards
                            electric. To find the most suitable electric cars or vans for our driver and business
                            requirements, we are trying models.</p>
                        </b-popover>
                    <div class="slider-spacer"></div>
                </div>
            </div>
        </div>
        <div class="row wrap">
            <div class="col"></div>
            <div class="full-slider col-8">
                <vue-slider
                        ref="slider"
                        v-model="maturity"
                        :data="dataPoints"
                        :tooltip="tooltip"
                        :tooltip-placement="'bottom'"
                        :dotSize="[60, 60]"
                        @drag-start="dragStart"
                >
                    <template v-slot:tooltip="{ value, focus }">
                        <div :class="['vue-slider-dot-tooltip-inner', 'vue-slider-dot-tooltip-inner-bottom']">
                            <span class="text-wrap">Drag this</span>
                        </div>
                    </template>
                    <template v-slot:dot="{ value, focus }">
                        <div class="custom-dot-inner"></div>
                    </template>
                </vue-slider>
            </div>
            <div class="col"></div>
        </div>
    </div>

</template>

<script>
    import BPopover from 'bootstrap-vue/es/components/popover/popover'
    import VueSlider from 'vue-slider-component'
    import 'vue-slider-component/theme/default.css'

    export default {
        name: 'RangeSelect',
        components: {
            VueSlider,
            BPopover
        },
        data() {
            return {
                dataPoints: [1, 2, 3, 4, 5],
                tooltip: 'always',
            };
        },
        methods: {
            next() {
                this.$store.dispatch('next');
            },
            dragStart() {
                this.tooltip = 'none';
            },
            setSelection(value) {
                this.maturity = value;
                this.tooltip = 'none'
            }
        },
        computed: {
            page() {
                return this.$store.state.current;
            },
            maturity: {
                get() {
                    return this.$store.state.selectedMaturity;
                },
                set(val) {
                    this.$store.commit('setSelectedMaturity', val);
                }
            },
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
    .slider-wrap
        width: 116.66%
        position: relative
        transform: translateX(-7.33%)

        .slider-bg
            width: 83.34%
            transform: translateX(10.26%)
            margin: 0
            text-align: center
            border-top: 0.2rem solid $color-grey-border
            border-bottom: 0.2rem solid $color-grey-border

            .col
                padding: 0
                border-right: 0.2rem dashed $color-grey-border

                &:nth-child(5)
                    border: none

            .description-block
                padding: 2rem 0.8rem

                .heading
                    font-weight: bold
                    color: $color-blue-petrol

                .slider-spacer
                    height: 14rem

        .wrap
            z-index: 10
            height: 14rem
            position: absolute
            bottom: 0
            left: 0
            right: 0
            margin: 0 !important

            .col
                padding: 0
                height: 14rem

            .full-slider
                padding: 0
                height: 14rem

                .vue-slider
                    height 0.2rem !important

                    .vue-slider-rail
                        border-radius: 0
                        background-color: $color-grey-border

                        .vue-slider-process
                            background-color: $color-blue-petrol

                        &:before
                            position: absolute
                            top: 0
                            left: 0.1rem
                            width: calc(100% / 8)
                            background-color: $color-blue-petrol
                            content: ""
                            display: block
                            height: 100%
                            transform: translateX(-100%)

                        &:after
                            position: absolute
                            top: 0
                            right: 0.1rem
                            width: calc(100% / 8)
                            background-color: $color-grey-border
                            content: ""
                            display: block
                            height: 100%
                            transform: translateX(100%)

                        .vue-slider-dot
                            border 0.2rem solid $color-blue-bright
                            background-color $color-white
                            border-radius 50%
                            padding: 2rem

                            &:hover
                                box-shadow: 0 0.2rem 0.5rem rgba(0, 0, 0, 0.3)

                            .custom-dot-inner
                                background-color $color-blue-petrol
                                width: 1.6rem
                                height: 1.6rem
                                border-radius 50%

                        .vue-slider-dot-focus
                            padding: 1.3rem

                            .custom-dot-inner
                                width: 3rem !important
                                height: 3rem !important
                                border-radius 50%

                        .vue-slider-dot-tooltip-inner
                            background-color: $color-grey-border
                            border-color: $color-grey-border
                            border-radius: 0
                            padding: 0
                            font-weight: bold
                            box-shadow: 0 0 0.5rem rgba(0, 0, 0, 0.3)
                            font-size 1.4rem
                            text-align center

                            .text-wrap
                                display: block
                                width: 9rem
                                height: 100%
                                padding: 1.5rem 1rem
                                color: $color-font
                                background-color: $color-white

                        .vue-slider-dot-tooltip-inner-bottom
                            &:after
                                top: -0.6rem
                                background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOBAMAAADd6iHDAAAAIVBMVEUAAAAAAAAAAADg4OAAAAAAAAAAAADj4+Pr6+sAAAD////DLD5VAAAACnRSTlMACwSSGhEHkIsVJ0tVtwAAAE9JREFUCNdjQAVMakkKUKaaoGASVFB0RmcgRFgxpGq5qxBE0HnVKhOwMGOI1apVi10FgExWoCBQOADIZAEKAoUdgEzmVWBgAGRyQZgLCDMBNBQoHbW3FxwAAAAASUVORK5CYII=")
                                transform: translate(-50%, -25%)
                                border: 0
                                width: 2rem
                                height: 1.4rem
                                content:""
                                position absolute
                                left 50%
</style>
